var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dsf-multiPage-home-view" },
    [
      _vm.page && _vm.page.menu_url
        ? _c("DsfMultiRouteView", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.show,
                expression: "show",
              },
            ],
            ref: "iframe",
            attrs: { name: _vm.name },
            on: { "route-complete": _vm.complete },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }